import API from "./index";

export const getHeaderData = async () => {
  const response = await API.get("/header");
  return response.data;
};

export const updateHeaderData = async (payload) => {
  const response = await API.post("/header", payload);
  return response.data;
};
